import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiService from '../../Services/apiServices';

const initialState = {
  items: [],
  status: 'idle',
  actionStatus: 'idle',
  error: null
};

export const fetchPartners = createAsyncThunk('partners/fetchPartners', async (_, thunkAPI) => {
  try {
    const response = await apiService.get('/barbellOSAdmin/partners/get');
    const payload = response.data?.data;
    return Array.isArray(payload) ? payload : [];
  } catch (error) {
    return thunkAPI.rejectWithValue(error?.response?.data?.detail || 'Failed to fetch partners');
  }
});

export const togglePartnerActivation = createAsyncThunk(
  'partners/toggleActivation',
  async ({ partnerId, activate }, thunkAPI) => {
    try {
      const route = activate ? '/barbellOSAdmin/partners/activate' : '/barbellOSAdmin/partners/de-activate';
      await apiService.put(route, null, { params: { partner_id: partnerId } });
      await thunkAPI.dispatch(fetchPartners());
      return true;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data?.detail || 'Failed to update partner');
    }
  }
);

const partnersSlice = createSlice({
  name: 'partners',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPartners.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchPartners.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload;
      })
      .addCase(fetchPartners.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Failed to fetch partners';
      })
      .addCase(togglePartnerActivation.pending, (state) => {
        state.actionStatus = 'loading';
        state.error = null;
      })
      .addCase(togglePartnerActivation.fulfilled, (state) => {
        state.actionStatus = 'succeeded';
      })
      .addCase(togglePartnerActivation.rejected, (state, action) => {
        state.actionStatus = 'failed';
        state.error = action.payload || 'Failed to update partner';
      });
  }
});

export default partnersSlice.reducer;
